"use client";
import { IUserData, IUsersBrandAccounts } from "@/types";
import { Label } from "@/components/ui/label";
import React from "react";
import { SetPronouns } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { IconUser } from "@tabler/icons-react";
import * as Impersonate from "@/lib/impersonate_api";

interface Props {
    user: IUserData;
    updateUser: IUserData;
    setUpdateUser: React.Dispatch<React.SetStateAction<IUserData>>;
    admin?: boolean;
    impersonate?: boolean;
    ws?: WebSocket | null;
    loggedInUser?: IUsersBrandAccounts | undefined;
}
export default function Pronoun({
    user,
    updateUser,
    setUpdateUser,
    admin,
    impersonate,
    ws,
    loggedInUser,
}: Props) {
    const [pronouns, setPronouns] = React.useState(
        updateUser.settings?.pronouns || ""
    );
    const onPronounsBlur = async () => {
        if (user.settings?.pronouns == updateUser.settings?.pronouns) return;
        const toastid = toast("Updating Pronouns...");
        if (impersonate && ws && loggedInUser?.role !== "user") {
            ws.send(
                JSON.stringify({
                    type: "update_header",
                    data: {
                        pic: updateUser.pic,
                        displayname: updateUser.displayname,
                        bio: updateUser.bio,
                        pronouns: updateUser.settings?.pronouns || "",
                        location: updateUser.settings.location,
                        layout: updateUser.theme.layout,
                        design: updateUser.design,
                    },
                })
            );
        }
        let response: any;
        if (impersonate) {
            response = await Impersonate.SetPronouns(
                user,
                updateUser.settings?.pronouns || ""
            );
        } else {
            response = await SetPronouns(
                user,
                updateUser.settings?.pronouns || ""
            );
        }
        response = await response.json();
        if (!response.error) {
            user.settings.pronouns = updateUser.settings?.pronouns || "";
            toast.success("Pronouns updated", { id: toastid });
        } else {
            toast.error(
                "Something went wrong, refresh and try again. If the issue persists, please log out and log back in",
                {
                    description: JSON.stringify(response),
                    id: toastid,
                }
            );
        }
    };

    return (
        <>
            {admin ? (
                <div className="flex items-end gap-1">
                    <Input
                        label="Pronouns"
                        labelIcon={<IconUser size={18} />}
                        variant="card"
                        className="w-full"
                        value={pronouns}
                        onChange={(e) => {
                            setPronouns(e.target.value);
                            setUpdateUser({
                                ...updateUser,
                                settings: {
                                    ...updateUser.settings,
                                    pronouns: e.target.value,
                                },
                            });
                        }}
                        onBlur={onPronounsBlur}
                    />
                </div>
            ) : updateUser.settings?.pronouns === "" ? (
                <Label variant="toggle" className={`${!admin && "hidden"}`}>
                    No bio set
                </Label>
            ) : (
                <p
                    id="user-pronouns"
                    className="flex items-center gap-1 text-lg"
                >
                    <IconUser size={18} /> {updateUser.settings?.pronouns}
                </p>
            )}
        </>
    );
}
